<template>
  <div class="ReportInstructions">
    <!-- 头 -->

    <Head :title="$tc('header.back')" :lanshow="ActiveName" />
    <!-- <NavBar class="nav-bar" /> -->

    <!-- 举报须知 -->
    <div class="detail-inner">
      <h5 class="mianbaoxie">
        <span>当前位置：</span><span>首页 </span><span> > {{ report_type }} </span>
      </h5>

      <div class="content">
        <div class="content-title" v-if="report_type">{{ report_type }}举报须知 <i></i></div>
        <div class="text">
          <div v-if="!d" v-html="text"></div>
          <div style="text-align:center" v-if="d"><img style="width:60vw" src="../../assets/img/empty.png" alt=""></div>
        </div>
        <div class="user-confirm">
          <div class="yuedu">
            <div style="padding-bottom:4vw">
              <input class="input" type="checkbox" :disabled="seconds !== 0" @change="changeInput" />我已阅读
              <span class="miao" v-if="seconds != 0">{{ seconds }}秒</span>
            </div>
            <div v-if="isShowTips" style="margin-bottom:3vw">请先阅读《举报须知》并勾选</div>
          </div>
          <div class="buttons">
            <van-button :class="seconds !== 0 && 'tongyi'" v-if="seconds === 0" @click="clickConfirm">
              同意
            </van-button>
            <van-button :class="seconds !== 0 && 'tongyi'" v-else>同意</van-button>
            <van-button type="default" class="butongyi" @click="clickReject">不同意</van-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 尾 -->
    <Footer />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'ReportInstructions',
  props: {},
  data () {
    return {
      seconds: 3,
      isShowTips: false,
      report_type: '',
      text: '',
      d: false
    }
  },
  created () {
    this.setShowLoading(false)
    // 用户是否登录
    const token =
      localStorage.getItem('userInfo') &&
      JSON.parse(localStorage.getItem('userInfo')) &&
      JSON.parse(localStorage.getItem('userInfo')).token
    if (token) {
      // 显示登陆头像
      this.setActiveName(true)
    } else {
      this.setActiveName(false)
    }
    if(this.$route.params.subId){
        this.getSubReportType(this.$route.params.subId)
    }else{
        this.reportType(this.$route.params.id)
    }
    
    if(this.$route.params.subId){
      this.init(this.$route.params.subId)
    }else{
      this.init(this.$route.params.id)
    }
    
  },
  methods: {
    ...mapMutations(['setShowLoading', 'setActiveName']),
    // 判断举报类型
    reportType (id) {
      this.$Api.reportTypeQueryReportType({ parentId: 0 }).then(res => {
        if (res) {
          this.report_type = (res || []).find(v => v.id / 1 === id / 1) ? (res || []).find(v => v.id / 1 === id / 1).typeName : ''
        }
      }).catch(() => {
        this.report_type = ''
      })
    },
    getSubReportType(id) {
      this.$Api.reportTypeQueryReportType({ parentId: this.$route.params.id }).then(res => {
        if (res) {
          this.report_type = (res || []).find(v => v.id / 1 === id / 1) ? (res || []).find(v => v.id / 1 === id / 1).typeName : ''
        }
      }).catch(() => {
        this.report_type = ''
      })
    },
    clickReject () {
      this.$router.push('/')
    },
    clickConfirm () {
      const input = document.querySelector('.input')
      if (!input.checked) {
        this.isShowTips = true
      } else {
        if(this.$route.params.subId){
          this.$router.push({
          path: `/reportDetails/${this.$route.params.id}/${this.$route.params.subId}`,
          // query: { id: this.$route.query.id }
        })
        }else{
          if(this.$route.params.id == 7){
            this.$router.push({
              path: `/reportInstructionsOther`,
              // query: { id: this.$route.query.id }
            })
          }else{
              this.$router.push({
                path: `/reportDetails/${this.$route.params.id}`,
                // query: { id: this.$route.query.id }
              })
          }
          
        }
        
      }
    },
    changeInput () {
      const input = document.querySelector('.input')
      if (input.checked && this.seconds === 0) {
        this.isShowTips = false
      }
    },
    // 须知的接口
    init (id) {
      this.$Api.reportTypeQueryReportTypeContent({ id }).then(res => {
        if (res) {
          this.text = res
        } else {
          // this.d = true
        }
      }).catch(err => {
        console.log(err)
        this.d = true
      })
    }
  },
  computed: {
    ...mapState(['ActiveName'])
  },
  watch: {
    seconds: function (newVal, oldVal) {
      if (newVal === 0) clearInterval(this.interval)
    }
  },
  components: {},
  mounted () {
    const that = this
    this.interval = setInterval(() => {
      that.seconds -= 1
    }, 1000)
  }
}
</script>

<style lang="scss" scoped>
.ReportInstructions {
  margin-top: 10.47vw;
  h5 {
    background-color: #f6f8fa;
  }
}
.content {
  .content-title {
    position: relative;
    text-align: center;
    padding: 3vw;
    font-size: 5vw;
    font-weight: 700;
    i {
      position: absolute;
      bottom: 0vw;
      left: 43.5vw;
      padding-left: 5vw;
      border-bottom: 1vw solid #2e76f3;
    }
  }
  padding: 4vw;
  .text {
    font-size: 3vw;
    // box-shadow: 1px 1px 3px 3px rgba(198, 198, 198, 0.9);

    margin: 3vw;
    padding-top: 6vw;
    padding-bottom: 6vw;
    border-top: 0.5vw solid #eeeeee;
    border-bottom: 0.5vw solid #eeeeee;
    > div {
      height: 62.7vw;

      overflow-y: scroll;
    }
    li {
      list-style-type: decimal;
    }
    ::v-deep .list-paddingleft-2 {
      padding-left: 3.5vw;
    }
  }
  .user-confirm {
    padding: 3vw;
    font-size: 3.5vw;
    .yuedu {
      // margin: 6vw 0 6vw 31vw ;
      text-align: center;
      font-weight: 700;

      input {
        vertical-align: top;
        margin-right: 1vw;
      }
      .miao {
        color: red;
        margin-right: 3vw;
      }
    }
    .buttons {
      text-align: center;
      margin: 0vw auto;
      font-weight: 700;
      div {
        width: 65vw;
      }
    }
  }
}
</style>
